import Link from 'next/link';
import Head from 'next/head';
import SocialMediaIconCollection from '@/components/Icons';

const Page = () => {
  return (
    <>
      <Head>
        <title>Icons</title>
      </Head>

      <h1>Icons</h1>
      <SocialMediaIconCollection />

      <h2>Icon-Welt</h2>
      <p>
        Auf dem{' '}
        <Link href="https://branding.fhnw.ch/" legacyBehavior>
          <a title="FHNW Branding Portal" target="_blank">
            FHNW Branding Portal
          </a>
        </Link>{' '}
        steht die offizielle Icon-Welt der FHNW in verschiedenen Formaten zum
        Download zur Verfügung. Falls Sie für einen Webdienst oder eine
        Applikation Icons einsetzen möchten, verwenden Sie bitte ausschliesslich
        diese.
      </p>
      <p>
        Bei Fragen zur Verwendung oder Ergänzungswünschen können Sie sich an{' '}
        <a href="mailto:kommunikation@fhnw.ch">kommunikation@fhnw.ch</a> wenden.
      </p>
    </>
  );
};

export default Page;
